export const novuConfig = {
  applicationIdentifier: import.meta.env.VITE_NOVU_APP_ID || 'Eu_w8OiBxDVy',
  backendUrl: import.meta.env.VITE_NOVU_SERVER_URL || 'https://notification-server.novavacation.com',
  // WebSocket 地址 - 自托管 Novu 的 WebSocket 服务器
  socketUrl: import.meta.env.VITE_NOVU_SOCKET_URL || 'wss://notification-ws.novavacation.com',
} as const

export type NovuConfig = typeof novuConfig
